/*
  Reservation pages. Included by the sign-up bands, the cabinet page's
  sign-up and the reserve page; the guard keeps it to one run per page.

  - Sign-up forms: keep the email for this tab, so the reserve button can
    open checkout with it filled in.
  - Reserve page: show the thank-you heading only to visitors who came from
    the sign-up (?signed_up=1).
  - Reserve button: after the deadline, swap it for the closed message. The
    server does the same on render; this covers pages Shopify cached before
    the deadline.
  - Order countdowns (snippets/order-countdown): tick every second. At zero,
    move on to the next stage if there is one (the reserve page counts down
    to reservations closing first); otherwise reload once so the page comes
    back with add to cart. If the countdown is still there after that reload
    (a cached page, or a device clock that runs fast), show the "orders are
    open" line with a reload link instead of reloading again.
*/
(function () {
  if (window.__vextReserve) return;
  window.__vextReserve = true;

  var EMAIL_KEY = 'vextReserveEmail';
  var RELOADED_KEY = 'vextCountdownReloaded:';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function startCountdown(el) {
    var end = Date.parse(el.getAttribute('data-target') || '');
    if (isNaN(end)) return;
    // Only pages for logged-in customers carry the server time; they aren't
    // cached, so it can correct a device clock that is off.
    var skew = 0;
    var serverNow = parseInt(el.getAttribute('data-server-now'), 10);
    if (!isNaN(serverNow)) skew = serverNow * 1000 - Date.now();

    var parts = {};
    el.querySelectorAll('[data-countdown-part]').forEach(function (p) {
      parts[p.getAttribute('data-countdown-part')] = p;
    });
    var timer;

    // A countdown with a next stage (the reserve page: reservations closing,
    // then ordering) moves on to it at zero, with its own heading and date,
    // instead of reloading.
    function advance() {
      var nextIso = el.getAttribute('data-next-target') || '';
      var next = Date.parse(nextIso);
      if (isNaN(next)) return false;
      end = next;
      el.setAttribute('data-target', nextIso);
      el.removeAttribute('data-next-target');
      var heading = el.querySelector('[data-countdown-heading]');
      var date = el.querySelector('[data-countdown-date]');
      var clock = el.querySelector('[role="timer"]');
      var headingText = el.getAttribute('data-next-heading') || '';
      var dateText = el.getAttribute('data-next-date') || '';
      if (heading) heading.textContent = headingText;
      if (date) date.textContent = dateText;
      if (clock) clock.setAttribute('aria-label', (headingText + ' ' + dateText).trim());
      return true;
    }

    function finish() {
      var key = RELOADED_KEY + window.location.pathname + ':' + end;
      // The theme editor can preview a countdown that has already ended; don't reload it.
      var reloaded = true;
      if (!(window.Shopify && window.Shopify.designMode)) {
        try {
          reloaded = sessionStorage.getItem(key) === '1';
          sessionStorage.setItem(key, '1');
        } catch (e) { /* storage blocked: never risk a reload loop */ }
      }
      if (!reloaded) {
        window.location.reload();
        return;
      }
      var ready = el.querySelector('[data-countdown-ready]');
      if (ready) ready.hidden = false;
      // A fresh query string gets past a cached copy of the page.
      var link = el.querySelector('[data-countdown-reload]');
      if (link) link.href = window.location.pathname + '?opened=' + Date.now();
    }

    function tick() {
      var left = Math.max(0, Math.floor((end - (Date.now() + skew)) / 1000));
      if (left === 0 && advance()) return tick();
      if (parts.days) parts.days.textContent = Math.floor(left / 86400);
      if (parts.hours) parts.hours.textContent = pad(Math.floor(left % 86400 / 3600));
      if (parts.minutes) parts.minutes.textContent = pad(Math.floor(left % 3600 / 60));
      if (parts.seconds) parts.seconds.textContent = pad(left % 60);
      if (left === 0) {
        clearInterval(timer);
        finish();
      }
    }

    tick();
    if (end - (Date.now() + skew) > 0) timer = setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('[data-reserve-email]').forEach(function (input) {
      input.form.addEventListener('submit', function () {
        try { sessionStorage.setItem(EMAIL_KEY, input.value.trim()); } catch (e) { /* storage blocked */ }
      });
    });

    if (new URLSearchParams(window.location.search).get('signed_up') === '1') {
      document.querySelectorAll('[data-reserve-signed-up]').forEach(function (el) { el.hidden = false; });
    }

    document.querySelectorAll('[data-countdown]').forEach(startCountdown);

    var email = '';
    try { email = sessionStorage.getItem(EMAIL_KEY) || ''; } catch (e) { /* storage blocked */ }
    document.querySelectorAll('[data-reserve-button]').forEach(function (wrap) {
      var end = Date.parse(wrap.getAttribute('data-deadline') || '');
      if (!isNaN(end) && Date.now() > end) {
        wrap.classList.add('is-closed');
        wrap.querySelector('.reserve-btn__closed').hidden = false;
      }
      var link = wrap.querySelector('[data-reserve-link]');
      if (link && email) {
        link.href = link.getAttribute('href').split('?')[0] + '?checkout[email]=' + encodeURIComponent(email);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
